import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useResourceHighlightDataSafe } from '../../../context/resourceDataContext.js';
import { HeaderWrapper } from '../../components/ModalResourceHeader.js';
import { IconLinkArrow } from '@fabric-app/icons/svg';
import { ExpandedResourceDropdownMenu } from '../../components/ExpandedResourceDropdownMenu.js';
import { ResourceHighlightText } from './ResourceHighlightText.js';
import { Modal } from '@fabric-app/ui/components/Modal/Modal';
import { LinkExternal } from '@fabric-app/ui/components/Link/LinkExternal';
import { ExpandedResourceTitle } from '../../components/ResourceTitle.js';
import { getOriginUrlWithHash } from '../../../../../resources/utils/getOriginUrlWithHash.js';

const ResourceContentText = () => {
  const { resource } = useResourceHighlightDataSafe();
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsxs(HeaderWrapper, {
        children: [
          /* @__PURE__ */ jsx(HeaderWrapper.Left, {
            children: /* @__PURE__ */ jsx(ExpandedResourceTitle, {})
          }),
          /* @__PURE__ */ jsxs(HeaderWrapper.Right, {
            children: [
              resource.originUrl && /* @__PURE__ */ jsx(Modal.IconButton, {
                as: LinkExternal,
                href: getOriginUrlWithHash(resource.originUrl, resource.id),
                children: /* @__PURE__ */ jsx(IconLinkArrow, {
                  style: {
                    width: 14
                  }
                })
              }),
              /* @__PURE__ */ jsx(ExpandedResourceDropdownMenu, {})
            ]
          })
        ]
      }),
      /* @__PURE__ */ jsx(ResourceHighlightText, {})
    ]
  });
};

export { ResourceContentText };
//# sourceMappingURL=ResourceContentText.js.map
